import React from "react";
import groceries from '../../assets/images/groceriesfff.png'; 
import { useTranslation } from 'react-i18next';
function Menutitle({ title }) {
  const { t } = useTranslation();
  return (

    <div className="Favourites_title">
        <div className="Favourites_title_l">
           <img className="bookmarkimgmenu" src={groceries} alt="" width="37" height="37" />
           <h2>{title || t("menu")}</h2>
        </div>
         
      </div>
    );
}

export default Menutitle;
